<template>
  <div class="case-content">
    <div class="container">
      <div class="case-img flex-container">
        <slot name="case-img"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pictureTrio',
}
</script>

<style lang="scss" scoped>

.flex-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;

    img{
      width: 33%;
      max-width: 370px;
      height: 100%;
      max-height: 320px;

      background: white;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05), 0 10px 7px 0 rgba(0,0,0,0.02);
      border-radius: 15px;
    }
}

@media screen and (max-width: 770px) {
  .flex-container{
    flex-direction: column;
  }
  .flex-container img{
    width: 100%;
    margin: 0 auto;
    margin-bottom: layout-val-8(4);
  }
}

</style>